import { render, staticRenderFns } from "./ConfirmAgreement.vue?vue&type=template&id=1586586d&scoped=true&"
import script from "./ConfirmAgreement.vue?vue&type=script&lang=js&"
export * from "./ConfirmAgreement.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmAgreement.vue?vue&type=style&index=0&id=1586586d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1586586d",
  null
  
)

export default component.exports